// extracted by mini-css-extract-plugin
module.exports = {"media":"MediaContainer_media__oiFi5","section":"MediaContainer_section__n57QH","imageText":"MediaContainer_imageText__Y_9Xf"};